<section id="ring" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="ring-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="ring-heading">{{ 'ring.title' | reportT }}</h2>
      <p class="section__desc">{{ 'ring.subtitle' | reportT }}</p>
    </div>
  </div>

  <div class="ring-grid">
    <article class="card ring-card" data-print-block>
      <div class="card-content ring-card__content">
        @if (gaps().length > 0) {
          <!-- L'enveloppe est le contexte de positionnement : le libellé
               central est un frère du graphique, jamais son enfant. -->
          <div class="ring-wrap">
            <div class="ring">
              <s2e-ring-chart
                [spokes]="subject().charts.ring"
                [(activeIndex)]="activeIndex"
                [theme]="chrome.theme()"
                [rtl]="chrome.rtl()"
                [codeDir]="codeDir()"
                [ariaLabel]="ringAria()"
                [statusLabel]="statusLabel()"
                [statusValue]="statusValue()"
                codePrefix=""
              />
            </div>

            <div class="ring__center" aria-hidden="true">
              <p class="ring__center-label">{{ 'ring.centerLabel' | reportT }}</p>
              <p dir="ltr" class="ring__center-value tabular">{{ subject().acquisition.notAcquired | reportFmt: 'num' }}<span class="ring__center-unit"> / {{ subject().acquisition.total | reportFmt: 'num' }}</span></p>
            </div>
          </div>

          <!-- Légende — le canal d'identité fiable quand l'anneau compte une
               quinzaine de secteurs. -->
          <ul class="ring-legend">
            @for (gap of gaps(); track gap.competencyId) {
              <li class="ring-legend__item reveal reveal--fade-up" s2eReveal [revealDelay]="$index * 15">
                <button type="button" class="ring-legend__btn"
                        [class.is-active]="activeIndex() === $index"
                        [attr.data-ring-index]="$index"
                        (mouseover)="activate($index)"
                        (focusin)="activate($index)"
                        (mouseleave)="clear()"
                        (focusout)="clear()">
                  <span class="ring-legend__swatch" [attr.data-cc]="gap.code"
                        [style.background-color]="gap.color" aria-hidden="true"></span>
                  <span class="ring-legend__code" dir="auto">{{ gap.shortCode }}</span>
                  <span class="ring-legend__name">{{ gap.title }}</span>
                </button>
              </li>
            }
          </ul>
        } @else {
          <!-- Aucune lacune : un anneau vide n'aurait rien à montrer, et un
               « aucune donnée » serait faux — tout est acquis, et c'est ce
               qu'il faut lire. -->
          <p class="insight-card__empty">{{ 'weaknesses.empty' | reportT }}</p>
        }
      </div>
    </article>

    <article class="card card--interactive meaning" data-print-block>
      <div class="card-content meaning__content">
        <div>
          <h3 class="meaning__title">{{ 'overview.summaryTitle' | reportT }}</h3>
          <p class="meaning__text" [innerHTML]="classification()"></p>
          <div class="meaning__badges">
            <span class="badge badge--{{ badgeVariant() }} badge--lg">{{ levelLabel() }}</span>
            @if (planBadge()) {
              <span class="badge badge--outline badge--lg">{{ planBadge() }}</span>
            }
          </div>
        </div>

        <dl class="level-counts">
          <div class="level-count level-count--acquired">
            <dt class="level-count__label">{{ 'competency.acquired' | reportT }}</dt>
            <dd class="level-count__value tabular">{{ subject().acquisition.acquired | reportFmt: 'num' }}</dd>
          </div>
          <div class="level-count level-count--notAcquired">
            <dt class="level-count__label">{{ 'competency.notAcquired' | reportT }}</dt>
            <dd class="level-count__value tabular">{{ subject().acquisition.notAcquired | reportFmt: 'num' }}</dd>
          </div>
        </dl>

        <div class="callout callout--soft">
          <span class="callout__icon"><svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg></span>
          <div class="callout__text">
            <p class="callout__title">{{ 'overview.recommendationTitle' | reportT }}</p>
            <p class="callout__body">{{ planDescription() }}</p>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>
